const ROLE_ALIASES = {
  ops: "compliance",
};

export const normalizeRole = (role) => {
  const normalized = String(role || "").trim().toLowerCase();
  return ROLE_ALIASES[normalized] || normalized;
};

export const roleMatches = (role, allowedRoles = []) => {
  const normalizedRole = normalizeRole(role);
  return allowedRoles.map(normalizeRole).includes(normalizedRole);
};

export const departmentDashboardPath = (role) => {
  const normalizedRole = normalizeRole(role);
  if (normalizedRole === "admin") return "/admin";
  if (["accounts", "compliance", "finance"].includes(normalizedRole)) {
    return `/admin/${normalizedRole}/dashboard`;
  }
  return "/dashboard";
};
